import i18n from "@/localization/i18n";
import { InitialRequestState } from "@/types/request.type";
import { getTranslationFormatNameFromAction } from "@/utils/translation";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: InitialRequestState = {};

const requestSlice = createSlice({
  name: "request",
  initialState,
  reducers: {
    setSuccess: (state, action: PayloadAction<string>) => {
      const type = action.payload;
      const tKey = `SERVER_SUCCESS.${getTranslationFormatNameFromAction(type)}`;
      if (!i18n.exists(tKey)) {
        return;
      }
      state.success = {
        type: getTranslationFormatNameFromAction(type),
        message: i18n.t(tKey)
      };
    }
  }
});

export const { setSuccess } = requestSlice.actions;
export default requestSlice.reducer;
